<template>
  <div :class="['toolbar-container', $mq]" v-bind:style="toolbarStyle">
    <div :class="['text-container', $mq]">
      <div class="logo-container">
        <img :src="`${clientResourcesUrl}logo.png?alt=media`" alt="App Logo" class="app-logo">
      </div>      

      <div class="text">
        <h1 class="title is-4">{{ verbiage.confirm_address_title }}</h1>
        <p v-html="paragraph"></p>
      </div>
    </div>
    
    <div :class="['controls', $mq]">      
      <b-button expanded @click="reenterAddress" class="prev-button">
        <close-circle-icon />
        RE-ENTER ADDRESS
      </b-button>
    
    
      <b-button expanded type="is-primary" @click="confirmAddress">
        <check-icon />
        YES
      </b-button>       
    </div>
  </div>
</template>

<style scoped>
  .toolbar-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-shadow: 0px 3px 6px var(--app-toolbar-shadow);
    padding: .8em;
    background-color: var(--app-toolbar-bg);
    color: var(--app-text);

    display: flex;
    flex-wrap: wrap;
  }

  div.text-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-grow: 1;
  }

  div.controls {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-grow: 1;
    padding-left: 10px;    
    justify-content: flex-end;
  }

  div.controls button {
    margin: 2px 5px;
    max-width: 200px;
  }

  /* Side-by-side buttons on all screen sizes */
  div.controls.lg, div.controls.md, div.controls.sm, div.controls.xs {
    flex-direction: row;
  }

  /* Mobile: smaller gap and full width buttons */
  div.toolbar-container.xs div.controls {
    width: 100%;
    gap: 0.5rem;
  }

  div.toolbar-container.xs div.controls button {
    max-width: none;
    flex: 1;
    margin: 0;
  }

  div.logo-container {
    padding: 5px 5px 0;
  }
   
  .app-logo {
    max-width: 100px;
  }  

  div.toolbar-container.xs div.logo-container {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  div.toolbar-container.xs div.logo-container .app-logo {
    max-width: 80px;
  }

  h1.title {
    margin-bottom: 0;
  }

  div.toolbar-container.xs h1.title {
    font-size: 1.3em;
    padding-bottom: 5px;
  }  

</style>

<script>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { useDialogsStore } from '@/stores/dialogs'
import { useConfig } from '@/composables/useConfig'

export default {
  setup() {
    const router = useRouter()
    const mainStore = useMainStore()
    const dialogsStore = useDialogsStore()
    const { verbiage, clientResourcesUrl } = useConfig()

    // Computed
    const hide = computed(() => mainStore.mapDrag)

    const toolbarStyle = computed(() => ({
      opacity: hide.value ? 0 : 1,
      visibility: hide.value ? 'hidden' : 'visible',
      transition: 'opacity 0.5s ease, visibility 0.5s ease'
    }))

    const formattedAddress = computed(() => {
      return mainStore.displayAddress || mainStore.address
    })

    const paragraph = computed(() => {
      return verbiage.value.confirm_address_paragraph.replace('{{ address }}', formattedAddress.value)
    })

    // Methods
    const confirmAddress = () => {
      router.push('/flow/tutorial')
    }

    const reenterAddress = () => {
      if (mainStore.getShapesArray().length > 0) {
        dialogsStore.confirm(0, `Re-entering the address will remove all measurement layers from the map. <br><br><span class="has-text-weight-bold">Are you sure?</span>`, {
          title: 'Warning',
          confirmText: 'Yes, re-enter address',
          cancelText: 'Cancel',
          type: 'is-primary',
          onConfirm: async () => {
            await mainStore.resetState()
            router.push('/flow/address-search')
          }
        })
        return
      }

      router.push('/flow/address-search')
    }

    // Lifecycle
    onMounted(() => {
      dialogsStore.snackbar('Drag the marker to center it above your property.', {
        duration: 5000
      })
    })

    return {
      hide,
      toolbarStyle,
      formattedAddress,
      paragraph,
      verbiage,
      clientResourcesUrl,
      confirmAddress,
      reenterAddress
    }
  }
}
</script>